import type { Guard } from './interfaces';

export const notAuthGuard: Guard = (from, to, { api }) => {
  return api.auth.isAuthenticated() ? '/' : true;
};
